import axiosInstance from '../../../config/axiosInstance';
import { AssetWarrantyDetailValisation } from "../View/Validation/AssetWarrantyDetailValisation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault();

    const formErrors = AssetWarrantyDetailValisation(formData);
    console.log('Validation Errors:', formErrors);
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.UserID = UserID;
            const response = await axiosInstance.post(`/Asset/UpdateWarrantyDetails`, formData);
            return response.data.message;
        } catch (error) {

            console.error('Error posting data:', error);
        }
    }
};

export { handleChange, handleSubmit };
